module.exports = __webpack_public_path__ + "img/m_c.67f1fbb5.png";